import { SWARM_DATA_RECEIVED, SWARM_UPDATE_RECEIVED } from "../actions/actionTypes";
import Helpers from "../helpers/helperFunctions";

/**
 * @name simplifySwarmData
 * @description Helper middleware function to catch updates and fire new event to process direct update
 * @param {function} store
 * @constructor
 * @fire event:CmsDataReceived
 * */
const simplifySwarmData = store => next => action => {
    let state = store.getState(),
        newAction,
        swarmData = state.swarmData.data[action.key];

    switch (action.type) {
        case SWARM_DATA_RECEIVED:
        case SWARM_UPDATE_RECEIVED:
            newAction = {
                ...action,
                payload: HandleSwarmData(swarmData, action, next, store)
            };
            delete newAction.meta;
            break;
    }

    return next(newAction || action);
};

const HandleSwarmData = (state, action, next, store) => {
    switch (true) {
        case SWARM_DATA_RECEIVED === action.type && action.meta && action.meta.simplify:
        case SWARM_UPDATE_RECEIVED === action.type && action.meta && action.meta.simplify:
            return simplify(state, action, next, store);
        case SWARM_DATA_RECEIVED === action.type:
        case SWARM_UPDATE_RECEIVED === action.type:
            return Helpers.cloneDeep(action.payload || {});
        default :
            return state;
    }
};

function simplify (state, action, next, store) {
    let {meta} = action, data, final;
    if (meta.parseToArray) {
        data = meta.objectToArray(meta.payloadKey ? Helpers.cloneDeep(action.payload[meta.payloadKey]) : Helpers.cloneDeep(action.payload), meta.keyName);
    }
    if (meta.sortingFunction && data) {
        data = data.sort(meta.sortingFunction);
    }
    if (meta.finalize) {
        final = meta.finalize(data || (meta.payloadKey ? Helpers.cloneDeep(action.payload[meta.payloadKey]) : Helpers.cloneDeep(action.payload)), action.key, store.getState());

        if (final.additionalActions) {
            final.additionalActions.map(actionCreator => {
                let newAction = actionCreator(action.key);
                next(newAction);
            });
        }
    }
    return final && final.initial || data || action.payload || state;
}

export default simplifySwarmData;